import { apiRequest, apiRequestEnvelope } from '@/api/http/fetch'

export interface NotificationItem {
  id: number
  userId: number
  type: string
  title: string
  body: string
  data?: Record<string, unknown>
  link?: string
  priority: string
  read: boolean
  readAt?: string
  createdAt: string
}

export interface NotificationsListResponse {
  items: NotificationItem[]
  total: number
  page: number
  limit: number
}

export function getNotifications(page = 1, limit = 20): Promise<NotificationsListResponse> {
  return apiRequestEnvelope<NotificationItem[]>(`/api/v1/notifications?page=${page}&limit=${limit}`)
    .then((resp) => ({
      items: resp.data ?? [],
      total: resp.meta?.total ?? 0,
      page: resp.meta?.page ?? page,
      limit: resp.meta?.limit ?? limit,
    }))
}

export function getUnreadCount(): Promise<{ unread: number }> {
  return apiRequest<{ unread: number }>('/api/v1/notifications/unread')
}

export function markNotificationRead(id: number): Promise<void> {
  return apiRequest<void>(`/api/v1/notifications/${id}/read`, { method: 'POST' })
}

export function markAllNotificationsRead(): Promise<void> {
  return apiRequest<void>('/api/v1/notifications/read-all', { method: 'POST' })
}
